export const getPublishedTemplateRecord = (store, templateId, location) => {
  const { sort, after, rowsPerPage } = location.query || {};
  const sortVars = {};
  if (sort) {
    sortVars.sort = sort;
  }
  const adoptedStore = store
    .getRoot()
    .getLinkedRecord("adoptedSystemDocumentTemplates", sortVars);
  if (!adoptedStore) {
    return;
  }

  const paginationVars = { first: rowsPerPage || 20, after: null || after };
  return adoptedStore.getLinkedRecord(
    "adoptedSystemDocumentTemplates",
    paginationVars
  );
};

export const getBlocSystemDocumentTemplatesDocuments = (
  store,
  templateId,
  location
) => {
  const { sort, after, rowsPerPage } = location.query || {};
  const root = store.getRoot();
  if (!root) {
    return null;
  }

  console.log("template->", templateId);
  const templateIdString = String(templateId);
  const vars = { pk: templateIdString };
  if (sort) {
    vars.sort = sort;
  }

  const blocTemplateDocuments = root.getLinkedRecord(
    "blocSystemDocumentTemplatesDocuments",
    vars
  );
  if (!blocTemplateDocuments) {
    return null;
  }
  const paginationVars = {
    first: rowsPerPage || 20,
    after: after || null
  };

  const linkedRecord = blocTemplateDocuments.getLinkedRecord(
    "blocSystemDocumentTemplates",
    paginationVars
  );
  return linkedRecord;
};
